<mat-card class="add-selective-master-dialog">
  <!-- Header -->
  <mat-card-header class="header-container">
    <mat-card-title>New Selective Master</mat-card-title>
    <button mat-icon-button (click)="close()"><mat-icon>close</mat-icon>
    </button>
  </mat-card-header>
  <mat-divider></mat-divider>
  <!-- Content -->
    <mat-card-content class="padding lrg all">
      <form [formGroup]="selectiveMasterForm" (keyup.enter)="create()">
        <!-- Name -->
        <div class="row">
          <mat-form-field floatLabel="always" appearance="outline" class="full-width">
              <mat-label
                for="name"
                [ngClass]="{
                  'error-message': fieldHasError(selectiveMasterForm, 'name'),
                  focus: focus.name
                }"
              >
                Name
              </mat-label>

            <div class="row">
              <input
                id="name"
                class="uppercase"
                 [ngClass]="{
                error: fieldHasError(selectiveMasterForm, 'name'),
                disabled: false,
                'focus-border': focus.name
                }"
                placeholder="Enter Selective Master Name"
                formControlName="name"
                (focus)="focusOn('name')"
                (focusout)="focusOn('name')"
                aria-describedby="name errors"
                cdkFocusInitial
                matInput
              />

              <mat-icon
                *ngIf="fieldHasError(selectiveMasterForm, 'name')"
                [size]="24"
                class="error-icon"
              >warning
              </mat-icon>
            </div>

            <!-- Errors -->
            <div *ngFor="let validation of errorMessages.name" id="nameErrors">
              <div class="caption error-message margin lrg top" *ngIf="fieldHasErrorMessages(selectiveMasterForm, validation, 'name')">
                {{ validation.message }}
              </div>
            </div>
          </mat-form-field>
        </div>
      </form>
    </mat-card-content>

  <!-- Buttons -->
  <mat-card-actions>
    <div class="row flex-end">
      <button mat-stroked-button id="cancel" (click)="close()"> Cancel </button>
      <button
        mat-flat-button
        class="margin left"
        [ngClass]="{'create-button': selectiveMasterForm.valid}"
        id="save"
        (click)="create()"
        [disabled]="!selectiveMasterForm.valid"
      >
        Create
      </button>
    </div>
  </mat-card-actions>
</mat-card>

